import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { cn } from "@/lib/utils";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll back to top"
      data-testid="back-to-top-button"
      className={cn(
        "fixed bottom-20 right-4 md:bottom-8 md:right-8 z-40",
        "h-12 w-12 md:h-14 md:w-14 rounded-full",
        "bg-navy-900 text-white border border-white/10",
        "shadow-[0_12px_30px_-8px_rgba(10,25,47,0.45)]",
        "grid place-items-center",
        "transition-all duration-500 ease-out",
        "hover:bg-gold hover:text-navy-950 hover:scale-105",
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-4 pointer-events-none"
      )}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
